module.exports = __webpack_public_path__ + "media/images/emblems/Wachseldorn-coat_of_arms-25e4ced15225022efd5e2acd1f536b8d.svg";